module.exports = "/shifts/components/shiftTemplatesComponent-730791.html";